let language = {
    "dashboard:header:Title": "Dashboard",
    "dashboard:part:Orders": "Orders",
    "dashboard:CustomerOrders": "Customer Orders",
    "dashboard:CustomerOrderDetail": "Order Detail",
    "dashboard:Combine": "Combine Orders",
    "dashboard:PartnerOrders": "Partner Orders",
    "dashboard:PartnerOrders:OrderDetails": "Order Details",
    "dashboard:PartnerOrders:OrderDetails:TransferInstructions": "Transfer Instructions",
    "dashboard:PartnerOrders:OrderDetails:TransferInformation": "Transfer Information",
    "dashboard:SampleOrders": "Sample Orders",
    "dashboard:SampleOrders:OrderDetails": "Order Details",
    "dashboard:SampleOrders:OrderDetails:TransferInstructions": "Transfer Instructions",
    "dashboard:SampleOrders:OrderDetails:TransferInformation": "Transfer Information",
    "dashboard:Returns": "Returns",
    "dashboard:ReturnsDetail": "Returns Detail",
    "dashboard:ReturnsRequest": "Returns Request",
    "dashboard:part:Products": "Products",
    "dashboard:MyProducts": "My Products",
    "dashboard:ProductsCatalog": "Product Catalog",

    "dashboard:ProductSticker": "Products Sticker",
    "dashboard:part:FileLibrary": "File Library",
    "dashboard:MySticker": "Sticker",
    "dashboard:MyBackground": "Background",
    "dashboard:MyForeground": "Foreground",
    "dashboard:MyFileLibrary": "Library",
    
    "dashboard:MyStores": "My Stores",
    "dashboard:MyStoreEmailSetting": "Tracking Email Setting",
    
    "dashboard:part:MyStores": "My Stores",
    
    "dashboard:part:MyAccount": "My Account",
    "dashboard:Payments": "Payments",
    "dashboard:AddressBook": "Address Book",
    "dashboard:AddressBookDetail": "Address Book ",
    "dashboard:Business": "Business Info",
    "dashboard:BillingMethods": "Billing Methods",
    "dashboard:BillingMethod": "New Billing Method",
    "dashboard:Taxes": "Taxes",
    "dashboard:MyAccount": "Profile Settings",
    "dashboard:CombineOrderSettings": "Combine Order Settings",
    

    "route:homepage": "Home page"
};

export { language }